<div class="terms-form">
  <div class="terms-form__row">
    @if (allowToggleSettings()) {
      <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" [formControl]="monitorProblematicIndCtrl()">
        <ng-container *ngTemplateOutlet="toggleText"></ng-container>
      </mat-slide-toggle>
    } @else {
      <ng-container *ngTemplateOutlet="toggleText"></ng-container>
    }
  </div>

  <ng-template #toggleText>
    <div class="terms-form__row-title">
      <span class="fs__md fw__500">Monitor Inappropriate or Unwanted Responses</span>
      <span class="fs__sm caption">Add words or phrases for this question that should be flagged or blocked when they're used.</span>
    </div>
  </ng-template>

  @if (monitorProblematicIndCtrl().value) {
    <mat-divider class="separator"></mat-divider>

    <mat-card class="terms-form__card">
      <mat-card-content class="terms-form__card__flags">
        <div class="terms-form__card__flags__title">
          <fa-icon [icon]="faGear"></fa-icon>
          <span class="fs__md fw__500">Standard Detection</span>
        </div>

        <div class="terms-form__card__flags__row">
          <div class="terms-form__card__flags__row__description">
            <span class="fs__sm fw__600">Profanity Filter</span>
            <span class="fs__sm fw__400 caption">Automatically flag or block responses containing offensive language.</span>
          </div>

          <div class="terms-form__card__flags__row__action">
            <empathy-icon-tooltip [icon]="faInfoCircle" [color]="'light'" [tooltip]="tooltip"></empathy-icon-tooltip>

            <mat-select [formControl]="flagCurseWordsIndCtrl()" aria-label="Disable, Flag or Block responses containing profanity.">
              @for (option of profanityFilterOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.text }}</mat-option>
              }
            </mat-select>
          </div>
        </div>

        <div class="terms-form__card__flags__row">
          <div class="terms-form__card__flags__row__description">
            <span class="fs__sm fw__600">Gibberish Filter</span>
            <span class="fs__sm fw__400 caption">Automatically flag or block responses containing random or nonsensical text.</span>
          </div>

          <div class="terms-form__card__flags__row__action">
            @if (gibberishSupported()) {
              <mat-slide-toggle
                [color]="'primary'"
                [formControl]="flagGibberishIndCtrl()"
                [attr.data-testid]="questionLevel() ? 'question-gibberish-toggle' : 'survey-gibberish-toggle'"
                aria-label="Gibberish Filter"
              ></mat-slide-toggle>
            } @else {
              <div class="coming-soon">
                <fa-icon [icon]="faLock" color="light"></fa-icon>
                <span class="fs__xs fw__400">Coming soon</span>
              </div>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="terms-form__custom">
      <div class="terms-form__row-title">
        <span class="fs__md fw__500">Custom filter</span>
        <span class="fs__sm caption">{{
          questionLevel()
            ? 'Specify custom terms to be flagged or blocked at this specific question.'
            : 'Specify custom terms to be flagged across all open end responses.'
        }}</span>
      </div>

      <mat-card class="terms-form__card">
        <mat-card-content class="terms-form__card__message">
          <div class="terms-form__card__message__check">
            <mat-checkbox
              color="primary"
              [checked]="customErrorMessageIndCtrl().value"
              (change)="customErrorMessageIndCtrl().setValue($event.checked)"
            ></mat-checkbox>

            <div class="terms-form__card__message__check__row">
              <span class="fs__sm fw__600">Apply custom error message</span>
              <span class="fs__sm fw__400 caption">Display a custom error message any time the custom filter validation fails.</span>
            </div>
          </div>

          @if (customErrorMessageIndCtrl().value) {
            <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="terms-form__card__message__textarea">
              <textarea matInput [formControl]="customErrorMessageCtrl()" autocomplete="off" placeholder="Enter custom error message"></textarea>
            </mat-form-field>
          }
        </mat-card-content>
      </mat-card>

      @if (questionLevel()) {
        <mat-card class="terms-form__custom__card">
          <mat-card-content class="terms-form__custom__card__content">
            <div class="terms-form__custom__card__content__title">
              <span class="fs__md fw__500">Survey level terms</span>

              <button mat-button color="primary" (click)="openSettingsTab()">
                <span class="fs__sm fw__500">Manage </span>
                <fa-icon [icon]="faArrowUpRightFromSquare" color="primary"></fa-icon>
              </button>
            </div>

            <mat-card class="terms-form__custom__card__info">
              <mat-card-content>
                <fa-icon [icon]="faInfoCircle" color="light"></fa-icon>
                <span class="fs__sm fw__500">These terms are applied to all open-ended questions in your survey</span>
              </mat-card-content>
            </mat-card>
          </mat-card-content>
        </mat-card>
      }

      <div class="terms-form__custom__subrow">
        <div class="terms-form__custom__subrow__header">
          <span class="label fs__sm fw__600">Block Responses containing these words</span>
          <button mat-icon-button title="Show block responses" (click)="showBlockTerms$.set(!showBlockTerms$())">
            <fa-icon [icon]="showBlockTerms$() ? faChevronUp : faChevronDown"></fa-icon>
          </button>
        </div>

        <div class="terms-form__custom__subrow__content" [@toggleContent]="showBlockTerms$() ? 'visible' : 'hidden'">
          <div class="terms-form__custom__subrow__content__header">
            @if (blockedTermsCtrl().controls?.length > 1) {
              <mat-checkbox
                color="primary"
                [checked]="this.selectedBlockTerms$().length === blockedTermsCtrl().controls.length"
                [labelPosition]="'after'"
                (change)="onSelectAllBlockTerms($event.checked)"
              >
                <span class="fs__sm fw__400">Select all</span>
              </mat-checkbox>
            }

            <div class="terms-form__custom__subrow__content__header__actions">
              <button mat-button color="light" class="terms-form__custom__subrow__content__header__actions-csv" (click)="onOpenBlocksImportCsvDialog()">
                <fa-icon [icon]="faCloudArrowUp" color="light"></fa-icon>
                <span class="fs__sm fw__600">Import CSV</span>
              </button>

              @if (selectedBlockTerms$().length) {
                <div class="terms-form__custom__subrow__content__header__actions__selection">
                  <span class="label fs__sm fw__400">{{ selectedBlockTerms$().length }} Selected</span>
                  <button mat-icon-button title="Open actions menu" [matMenuTriggerFor]="menu">
                    <fa-icon [icon]="faEllipsisVertical" color="light"></fa-icon>
                  </button>

                  <button mat-icon-button title="Remove selection" (click)="selectedBlockTerms$.set([])">
                    <fa-icon [icon]="faClose" color="light"></fa-icon>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onSetAllSelectedBlocksToContains()">
                      <span>Set to contains</span>
                    </button>
                    <button mat-menu-item (click)="onSetAllSelectedBlocksToExact()">
                      <span>Set to exact match</span>
                    </button>
                    @if (blockedTermsCtrl().controls.length > 1) {
                      <button mat-menu-item (click)="onDeleteAllSelectedBlocks()">
                        <span>Delete</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              }
            </div>
          </div>

          <div class="terms-form__custom__subrow__content__terms">
            @for (blockWordCtrl of blockedTermsCtrl().controls; track blockWordCtrl.value) {
              <empathy-terms-form-term-item
                [termGroup]="blockWordCtrl | toFormGroup"
                [allowDelete]="blockedTermsCtrl().controls.length > 1"
                [selected]="selectedBlockTerms$().includes($index)"
                [focus]="$last"
                (deleteTerm)="onDeleteBlockTerm($index)"
                (selectTerm)="onSelectBlockTerm($index, $event)"
                (pasteTerms)="onBlocksPasteTerms($event, $index)"
                (add)="onAddNewBlockTerm()"
              ></empathy-terms-form-term-item>
            }
          </div>

          <div class="terms-form__custom__subrow__content__footer">
            <button mat-button color="primary" (click)="onAddNewBlockTerm()">
              <fa-icon [icon]="faPlus"></fa-icon>
              Add
            </button>
          </div>
        </div>
      </div>

      <div class="terms-form__custom__subrow">
        <div class="terms-form__custom__subrow__header">
          <span class="label fs__sm fw__600">Flag responses containing these words</span>
          <button mat-icon-button title="Show flag responses" (click)="showFlagTerms$.set(!showFlagTerms$())">
            <fa-icon [icon]="showFlagTerms$() ? faChevronUp : faChevronDown"></fa-icon>
          </button>
        </div>

        <div class="terms-form__custom__subrow__content" [@toggleContent]="showFlagTerms$() ? 'visible' : 'hidden'">
          <div class="terms-form__custom__subrow__content__header">
            @if (flaggedTermsCtrl().controls?.length > 1) {
              <mat-checkbox
                color="primary"
                [checked]="this.selectedFlagTerms$().length === flaggedTermsCtrl().controls.length"
                [labelPosition]="'after'"
                (change)="onSelectAllFlagTerms($event.checked)"
              >
                <span class="label fs__sm fw__400">Select all</span>
              </mat-checkbox>
            }

            <div class="terms-form__custom__subrow__content__header__actions">
              <button mat-button color="light" class="terms-form__custom__subrow__content__header__actions-csv" (click)="onOpenFlagsImportCsvDialog()">
                <fa-icon [icon]="faCloudArrowUp" color="light"></fa-icon>
                <span class="fs__sm fw__600">Import CSV</span>
              </button>

              @if (selectedFlagTerms$().length) {
                <div class="terms-form__custom__subrow__content__header__actions__selection">
                  <span class="label fs__sm fw__400">{{ selectedFlagTerms$().length }} Selected</span>
                  <button mat-icon-button title="Open actions menu" [matMenuTriggerFor]="menu">
                    <fa-icon [icon]="faEllipsisVertical" color="light"></fa-icon>
                  </button>

                  <button mat-icon-button title="Remove selection" (click)="selectedFlagTerms$.set([])">
                    <fa-icon [icon]="faClose" color="light"></fa-icon>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onSetAllSelectedFlagsToContains()">
                      <span>Set to contains</span>
                    </button>
                    <button mat-menu-item (click)="onSetAllSelectedFlagsToExact()">
                      <span>Set to exact match</span>
                    </button>
                    @if (flaggedTermsCtrl().controls.length > 1) {
                      <button mat-menu-item (click)="onDeleteAllSelectedFlags()">
                        <span>Delete</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              }
            </div>
          </div>

          <div class="terms-form__custom__subrow__content__terms">
            @for (blockWordCtrl of flaggedTermsCtrl().controls; track blockWordCtrl.value) {
              <empathy-terms-form-term-item
                [termGroup]="blockWordCtrl | toFormGroup"
                [allowDelete]="flaggedTermsCtrl().controls.length > 1"
                [selected]="selectedFlagTerms$().includes($index)"
                [focus]="$last"
                (deleteTerm)="onDeleteFlagTerm($index)"
                (selectTerm)="onSelectFlagTerm($index, $event)"
                (pasteTerms)="onFlagsPasteTerms($event, $index)"
                (add)="onAddNewFlagTerm()"
              ></empathy-terms-form-term-item>
            }
          </div>

          <div class="terms-form__custom__subrow__content__footer">
            <button mat-button color="primary" (click)="onAddNewFlagTerm()">
              <fa-icon [icon]="faPlus"></fa-icon>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
